export default __webpack_public_path__ + "static/media/restaurant.cd9be87e.svg";